<script lang="ts">
	export let coverColor = `rgba(240,240,244,0.6)`;
	export let alignCenter = false;

</script>

<div class="cover" style={`background-color : ${coverColor}`} class:alignCenter>
	<slot />
</div>

<style lang="scss">
	.cover {
		top: 0px;
		left: 0px;
		bottom: 0px;
		right: 0px;
		position: absolute;
		z-index: 99;

		&.alignCenter {
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}

</style>
